import {
  Checkbox,
  TableCell,
  TableRow,
  Button,
  Snackbar,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";

import StatusDropdown from "../../../../common/StatusDropdown";
import { routes, showNotification } from "../../../../constants";
import { AddAdminSendInviteModal } from "../../../Admins/components/components";
import {
  addContributor,
  updateContributor,
  checkUserExist,
  checkContributorInviteExist,
  addContributorsInvites,
  updateContributorInvite,
} from "../../hooks/ContributorsHook";
import { sendgridEmail } from "../../../AreaManagement/hooks/AreaHook";
import { useAuth } from "../../../../hooks";
import { useContributorsContext } from "../../../../providers/OrganizationAdmin/ContributorsProvider";
import { Toast } from "../../../../common/alert";
import { getEmailTemplate } from "../../../../emails/EmailTemplate";
import { getSingleUser } from "../../../OrganizationQuickTales/hooks/QuickTalesHooks";
import { useOrganizationContext } from "../../../../providers/OrganizationAdmin/OrganizationProvider";

const TableRowSectionContributors = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleNavigateToDetails,
  columnWidths,
}) => {
  const { currentUser, organizationId } = useAuth();
  const { setLoading, handleGetAllContributors, loading } =
    useContributorsContext();
  const { currentOrganization, handleGetOrganization } =
    useOrganizationContext();

  React.useEffect(() => {
    handleGetOrganization();
  }, []);

  const [sendInviteModal, setSendInviteModal] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snakbarMessgae, setSnakbarMessgae] = useState("");

  const handleSendInviteModalOpen = () => {
    setSendInviteModal(true);
  };
  const handleSendInviteModalClose = () => {
    setSendInviteModal(false);
  };

  const handleSendInvite = async (userData) => {
    try {
      if (userData !== null) {
        setLoading(true);
        // let orgTemp = organizationId
        //   ? organizationId
        //   : currentUser.organization;
        // let dataTemp = {
        //   organization: orgTemp,
        //   status: "pending",
        //   firstName: userData.name,
        //   invitedBy: currentUser.id,
        //   invitedUserEmail: userData.email,
        //   userName: "",
        //   createdAt: new Date(),
        //   invitationToOrgDate: new Date(),
        //   // addedToOrgDate: new Date()
        // };
        // let id = null;
        // let userExist = await checkContributorInviteExist(userData.email);
        // if (userExist.status) {
        //   id = userExist.id;
        // } else {
        //   const response = await addContributorsInvites(dataTemp);
        //   id = response.id;
        // }

        // let userData = {
        //   name: row?.firstName + " " + row?.lastName,
        //   email: row?.invitedUserEmail,
        //   message: "",
        // }

        let redirectUrl = window.location.origin + "/accept-contributor-invite";
        redirectUrl = redirectUrl + "/" + row?.id + "/accepted";
        const htmlContent = getEmailTemplate(
          userData,
          "Contributor",
          redirectUrl,
          currentOrganization?.name,
          currentUser?.email
        );
        let name = userData.name;
        let text = userData.message;
        const message = {
          to: userData.email,
          from: process.env.REACT_APP_FROM_EMAIL,
          subject: "Contributor Invite",
          html: htmlContent,
        };

        let responseTemp = await sendgridEmail(message);

        if (responseTemp) {
          handleSendInviteModalClose();
          setSnakbarMessgae("Invitation Sent!");
          setSnackbarOpen(true);
        }
        await handleGetAllContributors();
        showNotification("User have been added as a Contributor");
      }
    } catch (error) {
      console.log("error sending invite:", error.message);
      Toast("error", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateContributorStatus = async (status) => {
    console.log(row.id);
    console.log(status);
    try {
      setLoading(true);
      let userResponse = await getSingleUser(row?.userId);
      if (
        userResponse?.data() &&
        userResponse?.data()?.organizations &&
        userResponse
          ?.data()
          ?.organizations?.includes(organizationId ?? currentUser.organization)
      ) {
        // showNotification(
        //   "This User is already a contributor to this Organization."
        // );
      } else {
        let dataTemp = {
          organizations: [
            ...(userResponse?.data()?.organizations ?? []),
            organizationId ?? currentUser.organization,
          ],
          updatedBy: currentUser.id,
          updatedAt: new Date(),
        };

        if (status === "accepted") {
          await updateContributor(row?.userId, dataTemp);
        }
      }

      let statusUpdateData = {
        updatedAt: new Date(),
        status: status,
        updatedBy: currentUser?.id,
      };
      await updateContributorInvite(statusUpdateData, row.id);
      await handleGetAllContributors();
      showNotification("Contributor status updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating status", error.message);
    } finally {
      setLoading(false);
    }
  };

  const dropdownOptions = ["accepted", "automatic", "inactive", "requested"];

  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 30,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        // component="th"
        id={labelId}
        // scope="row"
        padding="none"
        onClick={handleNavigateToDetails}
        style={{
          ...tableCellStyles,
          width: columnWidths?.firstName || 170,
          minWidth: columnWidths?.firstName || 170,
          maxWidth: columnWidths?.firstName || 170,
        }}
      >
        {row.firstName}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.lastName || 140,
          minWidth: columnWidths?.lastName || 140,
          maxWidth: columnWidths?.lastName || 140,
        }}
      >
        {row.lastName}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.userName || 140,
          minWidth: columnWidths?.userName || 140,
          maxWidth: columnWidths?.userName || 140,
        }}
      >
        {row.userName}
      </TableCell>

      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdAt || 170,
          minWidth: columnWidths?.createdAt || 170,
          maxWidth: columnWidths?.createdAt || 170,
        }}
      >
        {row.createdAt &&
          moment.unix(row.createdAt?.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.addedToOrgDate || 170,
          minWidth: columnWidths?.addedToOrgDate || 170,
          maxWidth: columnWidths?.addedToOrgDate || 170,
        }}
      >
        {row.updatedAt &&
          moment.unix(row.updatedAt?.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          ...tableCellStyles,
          width: columnWidths?.status || 140,
          minWidth: columnWidths?.status || 140,
          maxWidth: columnWidths?.status || 140,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <StatusDropdown
          options={dropdownOptions}
          currentValue={row?.status}
          onChange={handleUpdateContributorStatus}
        />
      </TableCell>
      {row?.status === "pending" && (
        // {row?.approvalStatus?.status === "pending" && (
        <TableCell padding="none" style={{ background: "#fff" }}>
          <Button
            variant="text"
            style={resendButtonStyles}
            onClick={handleSendInviteModalOpen}
          >
            Resend Invite
          </Button>
        </TableCell>
      )}
      <AddAdminSendInviteModal
        modalOpen={sendInviteModal}
        handleClose={handleSendInviteModalClose}
        handleSendInvite={handleSendInvite}
        row={row}
        loading={loading}
      />
      <Snackbar
        // anchorOrigin={{ vertical, horizantal }}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snakbarMessgae}
        // key={vertical + horizantal}
      />
    </TableRow>
  );
};

export default TableRowSectionContributors;

// const tableTitleFieldStyles = {
//   border: "1px solid #BABABA",
//   // paddingLeft: 5,
//   color: "#00A7CD",
//   fontWeight: 600,
//   fontFamily: "Avenir Book, sans-serif",
// };

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
  height: 30,
  paddingLeft: 10,
};
const tableStatusCellStyles = {
  border: "1px solid #BABABA",
  cursor: "pointer",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
  height: 30,
  paddingLeft: 10,
};
const resendButtonStyles = {
  textTransform: "none",
  background: "#fff",
  width: 120,
  color: "#00A7CD",
  fontFamily: "Avenir Book, sans-serif",
};
